const Index = () => import(/* webpackChunkName: "manager" */ './Index');

export default {
  routes: [
    {
      path: '/proj/fund/part/index',
      name: 'proj_fund_part_index',
      component: Index
    }
  ]
}
